import { createI18n, FallbackLocale } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';
import { ENV } from './constants';

const locale: string = ENV.VITE_PLANET_LOCALE || 'en';
const fallbackLocale: FallbackLocale = ENV.VITE_PLANET_FALLBACK_LOCALE || 'en';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  allowComposition: true,
  locale: locale,
  fallbackLocale: fallbackLocale,
  messages,
});

export default i18n;
